import { render, staticRenderFns } from "./PersonBubbleVector.vue?vue&type=template&id=3cf86952&"
import script from "./PersonBubbleVector.vue?vue&type=script&lang=js&"
export * from "./PersonBubbleVector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports